import { useEffect, useState } from 'react'

import { scrollToPosition } from 'lib/utils/scroll'

function useScrollTo({ ref, margin }) {
  const [shouldScroll, setShouldScroll] = useState(false)

  useEffect(() => {
    if (!shouldScroll) return
    scrollToPosition({ ref, margin })
    setShouldScroll(false)
  }, [shouldScroll, ref, margin])

  return {
    scroll: () => setShouldScroll(true),
  }
}

export default useScrollTo
